import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterModule } from '@angular/router';

import { PrimengSharedModule } from './primeng/primeng-shared/primeng-shared.module';
import { UnsavedFormDirective } from '@app/core/directives/unsaved-form.directive';

// Directivas
import { FadeSlideInOnceDirective } from './directives/fade-slide-in-once.directive';
import { FormularioDinamicoComponent } from './components/formulario-dinamico/formulario-dinamico.component';
// Componentes compartidos
import { CardComponent } from './card/card.component';
import { FormWrapperComponent } from './form-wrapper/form-wrapper.component';
import { FormStepComponent } from './form-step/form-step.component';
import { GlobalHeaderComponent } from './components/global-header/global-header.component';
import { FieldsetWrapperComponent } from './components/fieldset-wrapper/fieldset-wrapper.component';
import { ChartsModule } from './charts/charts.module';
import { ImgComponent } from './components/img/img.component';
import { CardAnimatedComponent } from './card-animated/card-animated.component';
import { CardsGridComponent } from './cards-grid/cards-grid.component';
import { FiltrosFlotanteComponent } from './components/filtros-flotante/filtros-flotante.component';
import { DialogModule } from 'primeng/dialog';
import { ExportarFlotanteComponent } from './components/exportar-flotante/exportar-flotante.component';
import { LimpiarFlotanteComponent } from './components/limpiar-flotante/limpiar-flotante.component';
import { ExplicacionComponent } from './components/explicacion/explicacion.component';
import { MathjaxComponent } from './components/mathjax/mathjax.component';
// import { RiesgoMatrizComponent } from '@app/modules/gestion-riesgos/components/matriz-riesgo/riesgo-matriz/riesgo-matriz.component';
import { DashboardDialogComponent } from './components/dashboard-dialog/dashboard-dialog.component';
import { WelcomeCardComponent } from './components/welcome-card/welcome-card.component';
import { CardWidgetComponent } from './components/card-widget/card-widget.component';
import { FormViewEditFormatComponent } from './components/form-view-edit-format/form-view-edit-format.component';
// (duplicate import removed)

//___________________________________________________________________________________________________
//Maia
import { TableComponent } from './components/table/table.component'
import { TarjetasDashboardComponent } from './components/tarjetas-dashboard/tarjetas-dashboard.component';
import { GerenciamientosComponent } from './components/gerenciamientos/gerenciamientos.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { FormsModule } from '@angular/forms';
import { RiesgoMatrizComponent } from '../modules/gestion-riesgos/components/matriz-riesgo/riesgo-matriz/riesgo-matriz.component';
import { FlotaCardsComponent } from './components/flota-cards/flota-cards.component';
import { ConductoresCardsComponent } from './components/conductores-cards/conductores-cards.component';
import { NuevaFlotaComponent } from './components/nueva-flota/nueva-flota.component';
import { InputErrorComponent } from './components/input-error/input-error.component';
import { EditarFlotaComponent } from './components/editar-flota/editar-flota.component';
import { NuevaAseguradoraComponent } from './components/nueva-aseguradora/nueva-aseguradora.component';
import { NuevaPolizaComponent } from './components/nueva-poliza/nueva-poliza.component';
import { VehiculosPolizaComponent } from './components/vehiculos-poliza/vehiculos-poliza.component';
import { AgregarNuevoComponent } from './components/agregar-nuevo/agregar-nuevo.component';
import { NuevoEventoComponent } from './components/nuevo-evento/nuevo-evento.component';
import { ConductorFormComponent } from './components/conductor-form/conductor-form.component';
import { DocumentosFormComponent } from './components/documentos-form/documentos-form.component';
import { NuevaEmpresaComponent } from './components/nueva-empresa/nueva-empresa.component';
import { UsuarioFormComponent } from './components/usuario-form/usuario-form.component';
import { PicklistLineaservicioComponent } from './components/picklist-lineaservicio/picklist-lineaservicio.component';
import { MenuFlotanteComponent } from './components/menu-flotante/menu-flotante.component';

//___________________________________________________________________________________________________
//Angelo
import { BotonesEstadoComponent } from './components/botones-estado/botones-estado.component';
import { FeedbackDialogComponent } from './components/feedback-dialog/feedback-dialog.component';
import { HasClaimDirective } from '@app/core/directives/render-claim.directive';


//___________________________________________________________________________________________________
//Giuliano

import { CardRecordatoriosComponent } from './components/card-recordatorios/card-recordatorios.component';
import { ConfirmationPanelComponent } from './components/confirmation-panel/confirmation-panel.component';
import { ImageUploaderComponent } from './components/image-uploader/image-uploader.component';

//___________________________________________________________________________________________________

@NgModule({
    declarations: [
        CardComponent,
        FormWrapperComponent,
        FormStepComponent,
        FadeSlideInOnceDirective,
        GlobalHeaderComponent,
        FieldsetWrapperComponent,
        UnsavedFormDirective,
        ImgComponent,
        CardAnimatedComponent,
        FormularioDinamicoComponent,
        CardsGridComponent,
        FiltrosFlotanteComponent,
        ExportarFlotanteComponent,
        LimpiarFlotanteComponent,
        ExplicacionComponent,
        MathjaxComponent,
        RiesgoMatrizComponent,
        CardWidgetComponent,
        WelcomeCardComponent,
        DashboardDialogComponent,
        TableComponent,
        TarjetasDashboardComponent,
        GerenciamientosComponent,
        CalendarComponent,
        FlotaCardsComponent,
        ConductoresCardsComponent,
        NuevaFlotaComponent,
        InputErrorComponent,
        EditarFlotaComponent,
        NuevaAseguradoraComponent,
        NuevaPolizaComponent,
        VehiculosPolizaComponent,
        CardRecordatoriosComponent,
        AgregarNuevoComponent,
        NuevoEventoComponent,
        ConfirmationPanelComponent,
        BotonesEstadoComponent,
        FeedbackDialogComponent,
        ConductorFormComponent,
        DocumentosFormComponent,
        NuevaEmpresaComponent,
        UsuarioFormComponent,
        PicklistLineaservicioComponent,
        MenuFlotanteComponent,
    ],
    imports: [
        FormsModule,
        CommonModule,
        RouterModule,
        PrimengSharedModule,
        ChartsModule,
        NgOptimizedImage,
        DialogModule,
        ImageUploaderComponent,
        FormViewEditFormatComponent,
        HasClaimDirective
    ],
    exports: [
        CommonModule,
        FormsModule,
        RouterModule,
        FormularioDinamicoComponent,

        // PrimeNG reutilizado
        PrimengSharedModule,

        // Directivas y componentes
        CardComponent,
        FormWrapperComponent,
        FormStepComponent,
        FadeSlideInOnceDirective, 
        GlobalHeaderComponent,
        FieldsetWrapperComponent,
        ImgComponent,
        CardAnimatedComponent,
        CardsGridComponent,
        RiesgoMatrizComponent,
        WelcomeCardComponent,
        DashboardDialogComponent,
        TableComponent,
        TarjetasDashboardComponent,
        GerenciamientosComponent,
        CalendarComponent,
        FlotaCardsComponent,
        ConductoresCardsComponent,
        NuevaFlotaComponent,
        AgregarNuevoComponent,
        NuevoEventoComponent,
        InputErrorComponent,
        ConductorFormComponent,
        DocumentosFormComponent,
        NuevaEmpresaComponent,
        UsuarioFormComponent,
        PicklistLineaservicioComponent,

        // Charts
        ChartsModule,
        FiltrosFlotanteComponent,
        ExportarFlotanteComponent,
        LimpiarFlotanteComponent,
        MenuFlotanteComponent,

    // MathJax
        ExplicacionComponent,
        MathjaxComponent,
        CardWidgetComponent,
        CardRecordatoriosComponent,
        ConfirmationPanelComponent,
        ImageUploaderComponent,
        FormViewEditFormatComponent,
        UnsavedFormDirective,
        BotonesEstadoComponent,
        FeedbackDialogComponent,
        HasClaimDirective,

    ]
})
export class SharedModule { }
// Verificar que SharedModule exporte los módulos de PrimeNG usados por formularios (InputTextModule, InputTextareaModule, DropdownModule)
